import ReactTooltip from "react-tooltip";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { HowIncreaseLevelV2 } from "../navigation/disclosure/Levels/HowIncreaseLevelV2";

export function Title() {
  return (
    <>
      <div className="flex">
        <div className="font-bold">Nivel de cliente </div>
        <div className="grid content-center justify-center font-bold">
          <QuestionMarkCircleIcon
            data-tip="React-tooltip"
            data-for="level"
            className="w-4 h-auto ml-0.5 cursor-pointer"
          />
          <ReactTooltip
            place="top"
            id="level"
            type="dark"
            effect="solid"
            className="w-60"
          >
            Cada nivel de cliente desbloquea descuentos y aumentos de cupo.
            Avanza de nivel invitando amigos a Galilea, usando tu cupo y
            pagando a tiempo tus créditos
          </ReactTooltip>
        </div>
      </div>
    </>
  );
}

export function LevelProgressbar() {
  const percentage = localStorage.getItem("percentLevel");
  return (
    <CircularProgressbar
      key={"circle-progress-bar-dashboardcredit"}
      className="d-flex align-items-center justify-content-center font-bold"
      value={percentage}
      text={`${localStorage.getItem('level') ?? 1}`}
      background
      backgroundPadding={2}
      styles={buildStyles({
        backgroundColor: "#F5F2FC",
        textSize: "40px",
        textColor: "#7E02FC",
        pathColor: "#7E02FC",
        trailColor: "#E1DFE5",
      })}
    />
  );
}

export function LevelData({setOpenCharacter}) {
  return (
    <div className="text-sm text-grayP">
      <div>Tus puntos: {localStorage.getItem('score') ?? 0}</div>
      <div>Te faltan {localStorage.getItem('scoreForNextLevel')} puntos para el siguiente nivel</div>
      {/* <HowIncreaseLevel setOpenCharacter={setOpenCharacter} /> */}
      <HowIncreaseLevelV2 setOpenCharacter={setOpenCharacter} />
    </div>
  );
}
